import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ngx-view-barcode",
  styleUrls: ["./view-barcode.component.scss"],
  templateUrl: "./view-barcode.component.html",
})
export class ViewBarcodeComponent implements OnInit, AfterViewInit {
  @Input() id?: string;
  @Input() barcode: string;
  @Input() title?: string;

  constructor() {}

  ngOnInit(): void {
    console.log("ViewBarcodeComponent/barcode:", this.barcode);

    // JsBarcode("#ean-13", this.barcode, {
    //   format: "ean13",
    //   font: "roboto",
    //   displayValue: true,
    //   height: 50,
    //   width: 1.7,
    //   margin: 0,
    // });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // JsBarcode(".barcode").init();
    }, 1000);
  }
}
